import { ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import Login from '@pages/auth/Login';
import { useAuthContext } from './useAuthContext';
import LoadingScreen from '@components/loading-screen';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isUserLoggedIn, userData, isCheckingRememberedUser } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (isCheckingRememberedUser) {
    return <LoadingScreen />;
  }

  if (!isUserLoggedIn && !userData) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
